<template>
  <v-container fluid class="batchdeposit-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-tabs color="primary">
          <v-tab :href="`#tab-deposit`" class="mr-5">
            <v-icon class="mr-3">mdi-text-box-outline</v-icon>
            Deposit
          </v-tab>
          <v-tab class="mr-5" :href="`#tab-items`" >
            <v-icon class="mr-3">mdi-drawing-box</v-icon>
            Items
          </v-tab>
          <v-tab-item :value="'tab-deposit'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">Deposit</p>
                      <v-select
                        readonly
                        class="mb-4"
                        :items="deposittype"
                        v-model="edit_deposit.deposittype"
                        v-on:change="onChangeBatchDeposit($event, 'deposittype')"
                        v-bind:error="errorindex == 0"
                        outlined
                        dense
                        placeholder="Type"
                        persistent-hint
                        single-line
                        hint="Please choose the deposit type"
                      >
                      </v-select>
                      <v-menu
                        :readonly="isNotEditable"
                        ref="menu_depositdate"
                        v-model="menu_depositdate"
                        :close-on-content-click="false"
                        :return-value.sync="depositdate"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            :readonly="isNotEditable"
                            outlined
                            dense
                            v-model="depositdate"
                            label="Deposit Date"
                            v-bind="attrs"
                            v-bind:value="depositdate"
                            v-on:change="
                              onChangeBatchDeposit($event, 'depositdate')
                            "
                            v-bind:error="errorindex == 1"
                            v-on="on"
                            single-line
                            hint="Please choose the deposit date"
                            persistent-hint
                          >
                            ></v-text-field
                          >
                        </template>
                        <v-date-picker
                          :readonly="isNotEditable"
                          v-model="depositdate"
                          no-title
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="primary"
                            @click="menu_depositdate = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="
                              onChangeBatchDeposit(
                                depositdate,
                                'depositdate'
                              );
                              $refs.menu_depositdate.save(depositdate);
                            "
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                      <v-switch
                        color="primary"
                        v-on:change="onChangeBatchDeposit($event, 'isTaxable')"
                        v-model="edit_deposit.isTaxable"
                        v-bind:value="edit_deposit ? edit_deposit.isTaxable : false"
                        hint="Taxable"
                        persistent-hint
                      ></v-switch>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-select
                        class="mb-4"
                        :items="data_accounts"
                        v-model="edit_deposit.accountid"
                        v-on:change="onChangeBatchDeposit($event, 'accountid')"
                        v-bind:error="errorindex == 2"
                        outlined
                        dense
                        placeholder="Account"
                        persistent-hint
                        single-line hint="Please choose the account">
                      </v-select>
                      <v-select
                        :readonly="isNotEditable"
                        class="mb-4"
                        :items="locations.map(x => {return {text: x.locationname, value: x._id};})"
                        v-model="edit_deposit.locationid"
                        v-on:change="onChangeBatchDeposit($event, 'locationid')"
                        v-bind:error="errorindex == 6"
                        outlined
                        dense
                        placeholder="Location"
                        persistent-hint
                        single-line hint="Please choose the location">
                      </v-select>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-text-field
                        :readonly="isNotEditable"
                        class="mb-4"
                        v-model="edit_deposit.depositby"
                        v-on:change="onChangeBatchDeposit($event, 'depositby')"
                        outlined
                        dense
                        placeholder="Deposit By"
                        persistent-hint
                        single-line hint="Enter deposit by">
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items="['New', 'Pending', 'Approved', 'Completed']"
                        v-model="edit_deposit.depositstatus"
                        v-on:change="onChangeBatchDeposit($event, 'depositstatus')"
                        outlined
                        dense
                        placeholder="Status"
                        persistent-hint
                        single-line
                        hint="Please choose the status"
                      >
                      </v-select>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/batchdeposit/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Cancel
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn
                        :loading="isReceiving"
                        class="button-shadow"
                        color="primary"
                        @click="updateBatchDeposit()"
                      >
                        Save
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-items'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row>
                  <v-col md="6">
                    <p class="text-h5">Items</p>
                  </v-col>
                  <v-col cols="6" sm="6" md="6" lg="6" class="d-flex flex-end justify-md-end overflow-auto" align="right">
<!--                     <v-btn
                      v-show="isEditable"
                      class="button-shadow mr-1"
                      color="success"
                      @click="isAddTransaction=true; new_transaction={}">
                      Add
                    </v-btn> -->
                    <v-btn
                      class="button-shadow mr-1"
                        to="/batchdeposit/list"
                        replace
                        color="primary"
                      >
                        Done
                    </v-btn>
                  </v-col>
                  </v-row>
                  <v-data-table
                        :headers="header_items"
                        :items="transactions"
                        :items-per-page="100"
                        :footer-props="footer"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteTransaction" width="500">
                            <v-card>
                              <v-card-title> Delete this Item? </v-card-title>
                              <v-card-text>
                                {{ delete_transaction.itemdesc }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteTransaction = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteTransaction(delete_transaction)"
                                  >Delete</v-btn
                                >
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.transimage="{ item }">
                          <v-img
                            v-bind:lazy-src="item.transimage"
                            min-width="50"
                            max-width="100"
                            v-bind:src="item.transimage"
                          ></v-img>
                        </template>
                        <template v-slot:item.transtype="{ item }">
                          {{ item.transtype }} {{ item.transnum }}
                        </template>
                        <template v-slot:item.transamount="{ item }">
                          {{ item.transamount.toFixed(2) }}
                        </template>
                        <template v-slot:item.transdate="{ item }">
                          {{ item.transdate!=null ? new Date(item.transdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '' }}
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            v-if="isEditable"
                            icon
                            color="primary"
                            @click="editTransactionDialog(item)"
                          >
                            <v-icon>mdi-pencil-outline</v-icon>
                          </v-btn>
                          <v-btn
                            v-if="isEditable"
                            icon
                            color="primary"
                            @click="deleteTransactionDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
    <div class="text-center">
      <v-dialog
        v-model="isEditTransaction"
        persistent
        width="800px"
        max-width="800px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Edit Transaction</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field
                    readonly
                    v-model="edit_transaction.transtype"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Type"
                    persistent-hint
                    single-line hint="Type">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    readonly
                    v-model="edit_transaction.transname"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Name"
                    persistent-hint
                    single-line hint="Name">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    type="number"
                    v-model="edit_transaction.transamount"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Amount"
                    persistent-hint
                    single-line hint="Amount">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isEditTransaction=false; edit_transaction={}"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="updateTransaction"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isUploadFile"
        persistent
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Upload File</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                <v-file-input label="File input" v-model="upload.file" v-on:change="onChangeFile" accept=".pdf" />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="upload.filename"
                    label="File Name"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isUploadFile = false; upload.file=null; upload.filename=''"
            >
              Close
            </v-btn>
            <v-btn
              :disabled="upload.file==null"
              color="blue darken-1"
              text
              @click="uploadFile"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { formatStdDate } from '@/mixins/date';
import router from "@/Routes";

export default {
  data() {
    return {
      header_items: [
        { text: 'Date', value: 'transdate', width: '8%'},
        { text: 'Type', value: 'transtype'},
        { text: 'Name', value: 'transname'},
        { text: 'Amount', value: 'transamount', width: '10%'},
        { text: "Actions", value: "actions", sortable: false, width: '10%' },
      ],
      classes: ['Cost of Good Sold', 'Administrative Expense', 'Operating Expense', 'Marketing Expense', 'Tax & Financing Expense', 'Factory & Production Expense', 'Debt & Loan', 'Overhead'],
      change_deposit: {},
      edit_deposit: {},
      
      deletefile: {},
      searchvendor: {},
      initvalue: {},
      edit_transaction: {},
      new_transaction: {},
      delete_transaction: {},

      upload: {filename: null,file: null},
      files: [],
      deposittype: ["Batch Deposit"],
      transactions: [],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      route: 0,



      menu_transdate: false,
      menu_transdate_edit: false,
      
      accountsubclass: null,
      accountsubclass2: null,

      depositdate: null,
      depositduedate: null,
      menu_depositdate: false,
      menu_depositduedate: false,


      isEditTransaction: false,
      isAddTransaction: false,
      isUploadFile: false,
      isDeleteFile: false,
      isDeleteTransaction: false,    
      errorindex: undefined,
    };
  },
  computed: {
    ...mapState("Account", ["accounts"]),
    ...mapState("BatchDeposit", ["isReceiving"]),
    ...mapState("Department", ["departments"]),
    ...mapState("Item", ["items"]),
    ...mapState("Location", ["locations"]),
    ...mapState("User", ["users"]),
    ...mapState("Vendor", ["vendors"]),
    data_accounts(){
      let result = this.accounts.filter(account=>account.accountsubclass=='Bank');
      let filter = this.accounts.filter(account=>account.accountname.includes('Advance') || account.accountname.includes('Prepayment'));
      let results = [...result, ...filter];
      return results.map(x => { return {text: x.accountname, value: x._id} });
    },
    isNotEditable(){
      let result = ['New','Credit','Partial','Pending','Audit','Void'].indexOf(this.initvalue.depositstatus) == -1;
      return result;
    },
    isEditable(){
      let result = ['New','Partial', 'Audit', 'Void'].indexOf(this.initvalue.depositstatus) >= 0;
      console.log(result);
      return result;
    }
  },
  methods: {
    ...mapActions("Account", ["getAccountsRequest"]),
    ...mapActions("BatchDeposit", ["deleteBatchDepositTransactionRequest", "getBatchDepositsRequest", "insertBatchDepositTransactionRequest", "updateBatchDepositRequest", "updateBatchDepositTransaction"]),
    ...mapActions("Brand", ["getBrandsRequest"]),
    ...mapActions("Department", ["getDepartmentsRequest"]),
    ...mapActions("File", ["insertRouteFile", "deleteFileRequest"]),
    ...mapActions("Item", ["getItemsRequest"]),
    ...mapActions("Location", ["getLocationsRequest"]),
    ...mapActions("User", ["getUsersRequest"]),
    checkError() {
      if (!this.accessname) {
        this.errorindex = 0;
        return false;
      }
      if (!this.accesspath) {
        this.errorindex = 1;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    checkTransaction(){
      if(!this.new_transaction.accountid){
        this.haserrors = true;
        this.errorindex = 11;
        return false;
      }
      if(!this.new_transaction.itemdesc){
        this.haserrors = true;
        this.errorindex = 12;
        return false;
      }
      if(!this.new_transaction.itemamount){
        this.haserrors = true;
        this.errorindex = 13;
        return false;
      }
      this.errorindex = -1;
      return true;
    },
    clearTransaction() {
      this.edit_transaction = {};
      this.new_transaction = {};
    },
    deleteTransactionDialog(item) {
      this.isDeleteTransaction = true;
      this.delete_transaction = {_id: item._id, itemname: item.itemname, itemdesc: item.itemdesc};
    },
    async deleteTransaction(payload) {
      this.isDeleteTransaction = false;
      let response = await this.deleteBatchDepositTransactionRequest(payload);
      let index = this.transactions.findIndex((trans) => trans._id == response._id);
      this.transactions.splice(index, 1);
      this.getBatchDepositsRequest();
    },
    async insertTransaction() {
      if(!this.checkTransaction()) return;
      let payload = Object.assign({depositid: this.initvalue._id}, this.new_transaction);
      console.log(this.new_transaction)
      let response = await this.insertBatchDepositTransactionRequest(payload);
      this.transactions.push(response);
      this.getBatchDepositsRequest();
      this.clearTransaction();
      this.isAddTransaction = false;
    },
    editTransactionDialog(item) {
      this.edit_transaction = Object.assign({}, item);
      this.isEditTransaction = true;
    },
    onChangeFile(file) {
      if (!file) this.upload.file = null;
      else this.upload.file = file;
    },
    onChangeBatchDeposit(value, field) {
      this.change_deposit[field] = value;
    },
  
    async updateBatchDeposit() {
      this.change_deposit._id = this.initvalue._id;
      await this.updateBatchDepositRequest(this.change_deposit);
      router.push("/batchdeposit/list");
    },
    async updateTransaction() {
      this.isEditTransaction = false;
      let json = {_id: this.edit_transaction._id, transamount: this.edit_transaction.transamount};
      let response = await this.updateBatchDepositTransaction(json);
      let index = this.transactions.findIndex((x) => x._id == response._id);
      this.transactions.splice(index, 1, response);
      this.clearTransaction();
      this.getBatchDepositsRequest();
    },
    async uploadFile(){
      this.isUploadFile = false;
      this.upload.id = this.initvalue._id;
      this.upload.route = 'deposit';
      let file = await this.insertRouteFile(this.upload);
      this.files.push(file);
      this.upload = {filename: null,file: null};
      this.getBatchDepositsRequest();
    },
  },

  async created() {
    this.initvalue = this.$route.params;
    if (!this.initvalue._id) this.$router.push({ name: "BatchDepositList" });
    this.edit_deposit = Object.assign({}, this.initvalue);
    this.depositdate = formatStdDate(this.initvalue.depositdate);

    if (this.accounts.length==0) await this.getAccountsRequest();
    if (this.locations.length==0) await this.getLocationsRequest();
    if (this.users.length==0) await this.getUsersRequest();

    this.files = this.initvalue.files;
    console.log(this.initvalue)
    this.transactions = Object.assign([], this.initvalue.transactions);
    
  },
};
</script>

<style src="./Edit.scss" lang="scss"></style>
